var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoungeExp = function SvgLoungeExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "#727582",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.334 12H2.667m10.667 0c.736 0 1.333-.597 1.333-1.334V8c0-.737-.597-1.333-1.333-1.333m0 5.333v1.333M2.667 12a1.333 1.333 0 0 1-1.333-1.334V8c0-.737.597-1.333 1.333-1.333m0 5.333v1.333m10.667-6.666c-.736 0-1.333.596-1.333 1.333v1.333H4V8c0-.737-.597-1.333-1.334-1.333m10.667 0v-2a2 2 0 0 0-2-2H4.667a2 2 0 0 0-2 2v2"
  })));
};
export default SvgLoungeExp;